import CitySEOHead from "@/components/feature/CitySEOHead";
import UTHeroSection from "./components/HeroSection";
import UTCitiesDirectory from "./components/CitiesDirectory";
import UTStateResources from "./components/StateResources";
import UTFAQSection, { faqs } from "./components/FAQSection";
import UTFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const servicesList = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens." },
  { name: "New Passport", description: "First-time passport application assistance." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service." },
  { name: "Child Passport", description: "Passport services for minors under 16." },
  { name: "Name Change", description: "Passport correction and name change service." },
  { name: "Second Passport & Damaged", description: "Second passport issuance and damaged passport replacement." },
];

export default function UtahPage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="Utah"
        state="Utah"
        stateAbbr="UT"
        route="/utah/"
        title="Utah Passport Services — Expedited & Emergency | Fast Passport Center"
        description="Expedited passport services across Utah — Salt Lake City, Provo, Ogden, St. George, Logan. Emergency processing as fast as 24 hours. A+ BBB rated courier service."
        geoPlacename="Utah, United States"
        geoPosition="39.3210;-111.0937"
        faqs={faqs.map(f => ({ q: f.question, a: f.answer }))}
        servicesSchema={servicesList}
      />
      <UTHeroSection />
      <UTCitiesDirectory />
      <UTStateResources />
      <UTFAQSection />
      <SEOCrossLinks state="UT" />
      <UTFinalCTA />
    </div>
  );
}